import { render, staticRenderFns } from "./DetalleAuditoria.vue?vue&type=template&id=278e8632"
import script from "./DetalleAuditoria.vue?vue&type=script&lang=js"
export * from "./DetalleAuditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports